// Chakra global style reference: https://github.com/chakra-ui/chakra-ui/blob/main/packages/css-reset/src/css-reset.tsx

import { color, fontFamily, fontSize, fontWeight, lineHeight, space } from '@core-ds/primitives';

export default {
   global: {
      body: `${fontFamily.lato}`,
      h1: {
         fontSize: `${fontSize['5xl']}`,
         fontWeight: 'revert',
         margin: `${space[1]} 0`,
         padding: '0',
         lineHeight: `${lineHeight.tight}`,
      },
      h2: {
         fontSize: `${fontSize['3xl']}`,
         fontWeight: `${fontWeight.semiBold}`,
         lineHeight: `${lineHeight.tight}`,
         margin: `${space[5]} 0 0`,
         padding: '0 0 2px 0',
      },
      h3: {
         fontSize: `${fontSize.xl}`,
         fontWeight: `${fontWeight.semiBold}`,
         lineHeight: `${lineHeight.tight}`,
         margin: `${space[4]} 0 0`,
         padding: '0',
      },
      h4: {
         fontSize: `${fontSize.md}`,
         fontWeight: 'revert',
         margin: `${space[1]} 0 0`,
      },
      h5: {
         fontSize: `${fontSize.md}`,
         margin: `${space[1]} 0 0`,
      },
      h6: {
         fontSize: `${fontSize.md}`,
         margin: `${space[1]} 0 0`,
      },
      a: {
         color: `${color.blue}`,
      },
      p: {
         marginTop: `${space[2]}`, // matches base.less value
         marginBottom: `${space[2]}`, // matches base.less value
      },
      'pre, code, kbd, samp': {
         fontFamily: 'unset',
         fontSize: 'unset',
      },
      'button, input, optgroup, select, textarea': {
         fontSize: `${fontSize.md}`, // set font-size to our rem value (14px)
      },
      'button, textarea': {
         padding: `${space[1]} ${space[2]}`, // matches forms.less value
      },
      select: {
         border: '1px solid #c1c1c1', // matches forms.less value
         fontFamily: 'inherit',
      },
   },
};
